<script>
export default {
  name: 'SearchBar',
}
</script>

<template lang="pug">
.form-group.mb-3
  input.w-100p(
    :placeholder="$t('search.placeholder')"
    @input="$emit('update', $event)"
    type="text"
  )
</template>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.collectomate {
  padding: 20px;
  border: solid $gray-lighter 1px;
  border-radius: 18px;
  margin-bottom: 1rem;
  position: relative;

  .collectomate-header {
    margin-bottom: 0.5rem;
  }

  .collectomate-address {
    font-size: 14px;
    margin-bottom: 0.5rem;
    color: $gray;
  }

  .btn-round-smaller {
    position: absolute;
    right: 15px;
    top: 50%;
    margin-top: -15px;

    .cl-close {
      display: block;
      transform: rotate(45deg);
      font-size: 12px;
    }
  }
}
</style>
